<template>
  <zm-dialog
    v-model="visible"
    append-to-body
    close-on-click-modal
    show-close
    top="8vh"
    custom-class="essential-app-dialog-wrap"
    @close="handleCancel"
    id="essential-app-dialog"
  >
    <div class="essential-dialog-header">
      <h2 class="dialog-title">{{$t('billing.essential_apps')}}</h2>
      <p class="dialog-subtext">{{$t('billing.essential_apps.dialog_desc')}}</p>
      <zm-button data-testid="checkout-button-5" type="link" @click="onSeeMoreClick">{{$t('billing.see_more_details')}}</zm-button>
    </div>
    <div class="essential-dialog-body" v-loading="isLoading">
      <ul class="app-category-list">
        <li>
          <!-- <h3 class="category-title">{{appCategory.title}}</h3> -->
          <ul class="app-item-list">
            <li v-for="appItem in appList" :key="appItem.id">
              <div class="app-card">
                <img :src="appItem.icon" class="app-icon"/>
                <div class="app-info">
                  <p class="app-name">{{appItem.appName}}</p>
                  <p class="app-author">by {{appItem.developName}}</p>
                </div>
                <p class="app-desc">{{appItem.description}}</p>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="essential-dialog-footer">
      <zm-button data-testid="checkout-button-6" type="link" @click="onSeeMoreClick" aria-label="See More Details about Essential Apps">{{$t('billing.see_more_details')}}</zm-button>
    </div>
    <p class="essential-dialog-legal" v-html="$t('billing.essential_app.legal_copy')"></p>
  </zm-dialog>
</template>

<script>
import { get } from 'lodash';
import {getEssentialAppList} from '@/apis';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { translation } from '@/plugins/i18n';
import {
  modalHybrid
} from '@/utils/modal-utils.js';

import { showModalDialogCloseButton, hideModalDialogCloseButton } from '@/utils/modal-utils.js';

export default {
  mixins: [ConfirmComponent],
  data () {
    return {
      visible: false,
      isLoading: false,
      appList: [],
    };
  },
  created() {
    this.$t = translation;
  },
  methods: {
    async initAppList () {
      this.isLoading = true;
      getEssentialAppList().then(res => {
        this.appList = get(res.result, 'items', []).map(app => {
          return {
            appId: app.application_id,
            appName: app.display_name,
            developName: app.company_name,
            description: app.description,
            icon: app.icon,
          };
        });
        this.isLoading = false;
      })
    },
    onSeeMoreClick () {
      if (modalHybrid.isInWebview) {
        modalHybrid.openLinkInBrowser('https://explore.zoom.us/en/zoom-apps/essential-app-bundle/');
      } else {
        window.open('https://explore.zoom.us/en/zoom-apps/essential-app-bundle/', '_blank');
      }
    },
  },
  watch: {
    visible (isVisible) {
      if (isVisible && this.appList.length === 0) {
        this.initAppList();
      }

      if (this.$context.is.modal) {
        isVisible ? hideModalDialogCloseButton() : showModalDialogCloseButton();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@use "sass:math";
@import '@/styles/scss-utils.scss';

$app-icon-size: 60px;
$dialog-width: 980px;
.essential-dialog-header {
  padding: 0 100px 20px 100px;
  margin-bottom: 30px;
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
  .dialog-title {
    color: #0E72ED;
    font-size: 32px;
    text-align: center;
    margin-bottom: 10px;
  }
  .dialog-subtext {
    color: #000;
    text-align: center;
    font-size: 16px;
  }
  & > button {
    margin: 0 auto;
    padding: 0;
    display: none;
  }
}
.essential-dialog-body {
  .app-category-list {
    list-style: none;
    padding: 0;
    & > li {
      &:not(:last-child) {
        margin-bottom: 40px;
      }
      .category-title {
        font-size: 24px;
        color:#000000;
        font-weight: 400;
        text-align: center;
        margin-bottom: 30px;
      }
    }
    .app-item-list {
      $column-gap: 30px;
      list-style: none;
      display: grid;
      padding: 0;
      grid-template-columns: repeat(2, calc(50% - #{math.div($column-gap, 2)}));
      column-gap: $column-gap;
      & > li {
        border-radius: 6px;
        margin-bottom: 10px;
        &:hover {
          background-color: var(--zoom-color-fill-subtler-neutral, #F7F9FA);
        }
        .app-card {
          padding: 10px;
          display: grid;
          grid-template-columns: ($app-icon-size + 12px) auto auto;
          grid-template-rows: auto-fill auto;
          grid-template-areas: 'icon info' 'icon desc';
          p {
            margin: 0;
          }
          .app-icon {
            flex: 0 0 $app-icon-size;
            height: $app-icon-size;
            width: $app-icon-size;
            border-radius: 12px;
            margin-right: 12px;
            grid-area: icon;
            & > img {
              width: $app-icon-size;
              height: $app-icon-size;
            }
          }
          .app-info {
            grid-area: info;
            display: flex;
            align-items: baseline;
            .app-name {
              font-size: 16px;
              color: #000;
              font-weight: 600;
            }
            .app-author {
              font-size: 14px;
              color: #515079;
              font-weight: 500;
              min-width: 80px;
              margin-left: 6px;
            }
          }
          .app-desc {
            font-size: 12px;
            color: #000000;
            font-weight: 500;
            word-break: break-word;
            grid-area: desc;
          }
        }
      }
    }
  }
}
.essential-dialog-footer {
  margin: 40px 0 20px 0;
  text-align: center;
  button {
    display: inline-block;
    color: #0B5CFF;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
.essential-dialog-legal {
  font-size: 12px;
  color: #515079;
  font-weight: 600;
  line-height: 1.42;
}
</style>
<style lang="scss">
$dialog-width: 980px;
#essential-app-dialog {
  height: 75vh;
  width: $dialog-width;
  display: flex;
  flex-direction: column;
  .zbo-dialog__body {
    height: 100%;
    overflow-y: auto;
    margin-top: 20px;
    padding: 0 60px;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar {
      width: 6px;
      height: 5px;
      cursor: pointer;
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-track {
      background-color: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      width: 7px;
      opacity: 0.4;
      border-radius: 7px;
      z-index: 99;
    }
    .essential-dialog-body {
      flex: 1 1 100%;
    }
  }
}
/* Mobile Style */
@media screen and (max-width: 1179px) and (min-width: 769px) {
  $dialog-width: 85%;
  #essential-app-dialog {
    width: $dialog-width;
    .zbo-dialog__body {
      padding: 0 20px;
      .essential-dialog-header {
        padding: 20px 40px;
      }
      .essential-dialog-body {
        .app-card .app-info {
          flex-direction: column;
          .app-author {
            margin-left: 0;
          }
        }
      }
    }
  }
  .essential-dialog-legal {
    width: $dialog-width !important;
    left: calc((100% - #{$dialog-width}) / 2) !important;
  }
}
@media screen and (max-width: 768px) {
  $app-icon-size: 44px;
  #essential-app-dialog {
    width: 85%;
    .zbo-dialog__header {
      button.zbo-dialog__headerbtn {
        right: 15px;
      }
    }
    .zbo-dialog__body {
      padding: 0 20px;
      .essential-dialog-header {
        padding: 0;
        .dialog-title {
          font-size: 24px;
          font-weight: 400;
          color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        }
        .dialog-subtext {
          font-size: 12px;
        }
        & > button {
          display: block;
        }
      }
      .essential-dialog-body {
        overflow-x: hidden;
        .category-title {
          font-size: 18px;
          color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
          margin-bottom: 24px;
        }
        .app-item-list {
          display: flex;
          flex-direction: column;
          & > li {
            margin: 0;
            padding: 0;
            &:hover {
              background-color: transparent;
            }
            .app-card {
              grid-template-columns: $app-icon-size auto;
              grid-template-rows: auto auto;
              grid-template-areas: 'icon info' 'desc desc';
              column-gap: 8px;
              row-gap: 8px;
              .app-icon {
                width: $app-icon-size;
                height: $app-icon-size;
              }
              .app-info {
                flex-direction: column;
                .app-name {
                  font-weight: 600;
                  font-size: 16px;
                }
                .app-author {
                  font-weight: 450;
                  font-size: 16px;
                  margin-left: 0;
                }
              }
              .app-desc {
                font-weight: 500;
                font-size: 12px;
              }
            }
            &:not(:last-child) {
              margin-bottom: 24px;
            }
          }
        }
      }
      .essential-dialog-footer {
        .footer-tip {
          text-align: left;
        }
        & > button {
          display: none;
        }
      }
    }
  }
  .essential-dialog-legal {
    width: 95% !important;
    left: 2.5% !important;
    height: 18vh !important;
  }
}
</style>
